import React from 'react';
import { Spinner, Table } from 'react-bootstrap';
import AddServiceIcon from '../../../../../assets/icons/add-service.png';
import RenderPagination from '../../../../../components/molecules/pagination';
import useRenderTableService from './hooks';
import {
  classNameHeader, renderDate, renderStatusService,
} from '../utils';
import { SERVICE_REASON_OPTIONS } from '../../../../../components/atoms/const';
import { Pencil } from '../../../../../components/atoms/icons';
import { getDaysRange } from '../../../../../components/atoms/func';

interface Props {
  status: number | string;
  page: {current: number, setCurrent: React.Dispatch<number>}
  // eslint-disable-next-line no-unused-vars
  renderVM: (type: number | null, deviceId: string | null, clientName: string | null) => React.ReactElement
}

function RenderTableService(props: Props) {
  const { status, page, renderVM } = props;
  const { service, navigate } = useRenderTableService(status, page.current);

  return (
    <div
      className="border border-1 border-color-stroke w-100 mb-4 py-2"
      style={{ borderRadius: '20px' }}
    >
      <Table borderless responsive>
        <thead>
          <tr>
            <th className={`${classNameHeader} ps-4 ps-xl-5`}>TICKET NUMBER</th>
            <th className={classNameHeader}>VENDING MACHINE (MACHINE ID)</th>
            <th className={classNameHeader}>REASON</th>
            <th className={classNameHeader}>TECHNICIAN</th>
            <th className={classNameHeader}>REQUEST DATE</th>
            <th className={classNameHeader}>AGING DATE</th>
            <th className={`${classNameHeader} text-center`}>ACTION</th>
            <th className={`${classNameHeader} pe-4 pe-xl-5`} style={{ width: 130 }}>STATUS</th>
          </tr>
        </thead>
        <tbody>
          {(() => {
            if (service.load) {
              return (
                <tr>
                  <td colSpan={7} className="text-center">
                    <div className="my-2"><Spinner animation="border" /></div>
                  </td>
                </tr>
              );
            } if (service.data && service.data?.length) {
              return service.data.map((data, i) => (
                <tr
                  // eslint-disable-next-line react/no-array-index-key
                  key={i}
                  className={i % 2 !== 0 ? 'bg-solid align-middle' : 'align-middle'}
                  style={{ height: '50px' }}
                >
                  <td className="fz-14" style={{ minWidth: 170 }}>
                    <div className="ps-4 ps-xl-5">{data.id ?? '-'}</div>
                  </td>
                  <td>
                    {renderVM(data.type, data.deviceId, data.clientName)}
                  </td>
                  <td className="fz-14">{SERVICE_REASON_OPTIONS.find((x) => x.value === data.serviceReason)?.label ?? '-'}</td>
                  <td className="fz-14">
                    {data.firstname || data.lastname ? `${data.firstname ? `${data.firstname} ` : ''}${data.lastname ?? ''}` : '-'}
                  </td>
                  <td className="fz-14" style={{ minWidth: 150 }}>
                    {renderDate(data.requestDate)}
                  </td>
                  <td className="fz-14" style={{ minWidth: 120 }}>
                    {getDaysRange(new Date(data.requestDate), new Date())}
                  </td>
                  <td className="fz-14" style={{ minWidth: 50 }}>
                    <div className="flexible-center">
                      <button
                        type="button"
                        onClick={() => navigate.edit(data.id)}
                        className="border-0 bg-transparent"
                      >
                        <Pencil />
                      </button>
                    </div>

                  </td>
                  <td className="fz-14 pe-4 pe-xl-5">
                    <div className="d-flex justify-content-end align-items center">
                      <div className="d-flex align-items-center justify-content-between" style={{ width: 130 }}>
                        <div className="rounded-pill px-3 py-1" style={renderStatusService(data.serviceStatus).style}>
                          {renderStatusService(data.serviceStatus).status}
                        </div>
                        <button
                          type="button"
                          className="border-0 bg-transparent"
                          onClick={() => navigate.invoice(data.id)}
                        >
                          <img src={AddServiceIcon} alt="addServiceIcon" width={26} style={{ marginBottom: '4px' }} />
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              ));
            }
            return (
              <tr>
                <td colSpan={7} className="text-center fz-14">
                  <div className="my-2">Data Not Found</div>
                </td>
              </tr>
            );
          })()}
        </tbody>
      </Table>
      <div className="d-flex align-items-center justify-content-end mt-4 pe-4 pe-xl-5">
        <RenderPagination
          currentPage={page.current}
          setCurrentPage={page.setCurrent}
          totalPage={service.totalPages}
        />
      </div>
    </div>
  );
}

export default React.memo(RenderTableService);
